module.exports = __webpack_public_path__ + "static/img/物业-2.f1c8214f.png";